const activeClass = 'is-active'

export default class {
  constructor(el, options) {
    this.el = el
    this.options = options

    const gridToggle = el.querySelector('.js-gridToggle')

    if (gridToggle) {
      const targetEl = document.querySelector(
        gridToggle.getAttribute('data-target')
      )
      const activeText = gridToggle.getAttribute('data-activetext')
      const originalText = activeText ? gridToggle.textContent : false

      gridToggle.addEventListener('click', function (e) {
        targetEl.classList.toggle(activeClass)

        if (targetEl.classList.contains(activeClass)) {
          gridToggle.textContent = activeText
        } else if (originalText) {
          gridToggle.textContent = originalText
        }

        e.preventDefault()
      })
    }
  }
}
